const ORG_DETAIL_VIEW_PATTERN =
  /\/detail\/(recommendations|org-trends|squad-scorecard|insights|analyze)(?:\/(\d+))?/;

const VIEWS_WITH_SUB_ORG = new Set(['recommendations', 'org-trends']);

export function orgDetailViewFromPath(pathname) {
  if (pathname == null) {
    return null;
  }

  const match = pathname.match(ORG_DETAIL_VIEW_PATTERN);
  return match?.[1] ?? null;
}

export function subOrgIdFromOrgDetailPath(pathname, defaultOrgId) {
  if (pathname == null) {
    return defaultOrgId;
  }

  const match = pathname.match(ORG_DETAIL_VIEW_PATTERN);

  if (!match) {
    return defaultOrgId;
  }

  const [, view, subOrgId] = match;

  if (!VIEWS_WITH_SUB_ORG.has(view)) {
    return defaultOrgId;
  }

  return subOrgId != null ? +subOrgId : defaultOrgId;
}

export function teamIdFromOrgDetailSearch(search) {
  const value = new URLSearchParams(search).get('teamId');

  return value != null && value !== '' ? value : null;
}

export function buildOrgDetailPath({
  workspaceId,
  orgId,
  assessmentKey,
  view,
  subOrgId,
  teamId,
}) {
  const base = `/w/${workspaceId}/orgs/${orgId}/${assessmentKey}/detail/${view}`;
  const pathname =
    VIEWS_WITH_SUB_ORG.has(view) && subOrgId != null
      ? `${base}/${subOrgId}`
      : base;
  const search =
    view === 'org-trends' && teamId != null
      ? `?teamId=${encodeURIComponent(teamId)}`
      : '';

  return { pathname, search };
}

export function buildOrgTrendsDetailPath({
  workspaceId,
  orgId,
  assessmentKey,
  subOrgId,
  teamId,
}) {
  return buildOrgDetailPath({
    workspaceId,
    orgId,
    assessmentKey,
    view: 'org-trends',
    subOrgId,
    teamId,
  });
}

export function buildRecommendationsDetailPath({
  workspaceId,
  orgId,
  assessmentKey,
  subOrgId,
}) {
  return buildOrgDetailPath({
    workspaceId,
    orgId,
    assessmentKey,
    view: 'recommendations',
    subOrgId,
  });
}
